<div class="modal-overlay" (click)="onClose()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>Background settings</h3>
      <button class="close-btn" (click)="onClose()">&times;</button>
    </div>

    <div class="bg-editor">
      <!-- Left: Type selector -->
      <div class="bg-panel bg-panel-left">
        <div class="bg-panel-label">Type</div>
        <div
          class="bg-type-item"
          *ngFor="let t of types"
          [class.selected]="selectedType === t.key"
          (click)="selectType(t.key)"
        >
          <nw-icon [type]="t.icon" [size]="14" color="#6b7280"></nw-icon>
          <span>{{ t.label }}</span>
        </div>
      </div>

      <!-- Center: Preview -->
      <div class="bg-panel bg-panel-center">
        <div class="bg-preview-toolbar" *ngIf="selectedType === 'image' && bgDef?.type === 'image'">
          <button
            class="toolbar-btn"
            [class.active]="showCrop"
            (click)="toggleCrop()"
            title="Edit crop"
          >
            <nw-icon type="crop" [size]="16" [color]="showCrop ? '#3b82f6' : '#6b7280'"></nw-icon>
          </button>
        </div>

        <nw-scene-preview
          *ngIf="!showCrop"
          [scene]="previewScene"
        ></nw-scene-preview>

        <nw-background-crop-preview
          *ngIf="showCrop"
          [backgroundDef]="bgDef"
          [animation]="scene?.background?.animation || {}"
          (cropChange)="onCropChange($event)"
        ></nw-background-crop-preview>
      </div>

      <!-- Right: Type-specific form -->
      <div class="bg-panel bg-panel-right">
        <!-- Image -->
        <ng-container *ngIf="selectedType === 'image'">
          <div class="bg-panel-label">Images</div>
          <div class="image-grid">
            <div
              class="image-thumb"
              *ngFor="let img of images"
              [class.selected]="selectedImageUrl === img.url"
              (click)="selectImage(img)"
            >
              <img [src]="getImageThumbUrl(img)" [alt]="img.fileName || 'image'" loading="lazy">
            </div>
          </div>
          <div class="bg-empty" *ngIf="!images.length">No images uploaded</div>
          <div class="upload-section">
            <label class="upload-btn">
              <nw-icon type="upload" [size]="14" color="#6b7280"></nw-icon>
              <span>Upload Image</span>
              <input
                type="file"
                accept="image/*"
                multiple
                (change)="onImageUpload($event)"
                hidden
              >
            </label>
          </div>
        </ng-container>

        <!-- Gradient -->
        <ng-container *ngIf="selectedType === 'gradient'">
          <div class="bg-panel-label">Gradient</div>
          <div class="bg-form">
            <div class="form-group">
              <div class="form-group-label">Colors</div>
              <div class="color-inputs">
                <label *ngFor="let c of gradientColors; let i = index" class="color-input">
                  <input
                    type="color"
                    [ngModel]="c"
                    (ngModelChange)="onGradientColorChange(i, $event)"
                  >
                  <span class="color-hex">{{ c }}</span>
                </label>
              </div>
            </div>
            <div class="form-group">
              <div class="form-group-label">Direction</div>
              <div class="direction-btns">
                <button
                  class="dir-btn"
                  [class.active]="gradientDirection === GradientDirection.Horizontal"
                  (click)="onGradientDirectionChange(GradientDirection.Horizontal)"
                >Horizontal</button>
                <button
                  class="dir-btn"
                  [class.active]="gradientDirection === GradientDirection.Vertical"
                  (click)="onGradientDirectionChange(GradientDirection.Vertical)"
                >Vertical</button>
                <button
                  class="dir-btn"
                  [class.active]="gradientDirection === GradientDirection.Diagonal"
                  (click)="onGradientDirectionChange(GradientDirection.Diagonal)"
                >Diagonal</button>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Solid -->
        <ng-container *ngIf="selectedType === 'solid'">
          <div class="bg-panel-label">Solid Fill</div>
          <div class="bg-form">
            <div class="form-group">
              <div class="form-group-label">Color</div>
              <label class="color-input">
                <input
                  type="color"
                  [ngModel]="solidColor"
                  (ngModelChange)="onSolidColorChange($event)"
                >
                <span class="color-hex">{{ solidColor }}</span>
              </label>
            </div>
          </div>
        </ng-container>

        <!-- Video -->
        <ng-container *ngIf="selectedType === 'video'">
          <div class="bg-panel-label">Videos</div>
          <div class="video-list" *ngIf="videos.length">
            <div
              class="video-item"
              *ngFor="let vid of videos"
              [class.selected]="videoUrl === vid.url"
              (click)="selectVideo(vid)"
            >
              <nw-icon type="videocam" [size]="14" color="#6b7280"></nw-icon>
              <span class="video-name">{{ vid.fileName || vid.id }}</span>
            </div>
          </div>
          <div class="bg-empty" *ngIf="!videos.length">No videos uploaded</div>
          <div class="upload-section">
            <label class="upload-btn">
              <nw-icon type="upload" [size]="14" color="#6b7280"></nw-icon>
              <span>Upload Video</span>
              <input
                type="file"
                accept="video/*"
                (change)="onVideoUpload($event)"
                hidden
              >
            </label>
          </div>
          <div class="bg-form">
            <div class="form-group">
              <div class="form-group-label">Or paste URL</div>
              <input
                type="text"
                class="url-input"
                [ngModel]="videoUrl"
                (ngModelChange)="onVideoUrlChange($event)"
                placeholder="https://..."
              >
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
